import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDropboxComponent } from './simple-icons-dropbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDropboxComponent ],
    exports:      [ SimpleIconsDropboxComponent ],
    bootstrap:    []
})
export class SimpleIconsDropboxModule {}
